window.app = window.app || {};
app.data = app.data || {};

app.data = {
    defaults: {},
    init: () => {
        app.data.defaults = {
            language: document.documentElement.lang ?? 'de'
        };
        app.data.isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1' || 
                     window.location.hostname === '::1';
    }
};